import { sis_nhomthanhphandiem } from './../../../models/response/so-diem/sis_nhomthanhphandiem';
import { eNhomThanhPhanDiemActionTypeIds } from './../../action-types/so-diem/INhomThanhPhanDiemActions';
import { BaseAction } from "../IBaseActionResult";

export const nhomThanhPhanDiemActions = {
    loadStart: () => BaseAction(undefined, eNhomThanhPhanDiemActionTypeIds.LOAD_START),
    loadSuccess: (respone: sis_nhomthanhphandiem[]) => BaseAction(respone, eNhomThanhPhanDiemActionTypeIds.LOAD_SUCCESS),
    loadError: (message: string) => BaseAction(message, eNhomThanhPhanDiemActionTypeIds.LOAD_ERRROR)
}